import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AdminOverview } from "@/components/admin/AdminOverview";
import { AdminArticles } from "@/components/admin/AdminArticles";
import { AdminSponsors } from "@/components/admin/AdminSponsors";
import { DataTable } from "@/components/admin/DataTable";
import { AdminNewsletter, AdminMonthly } from "@/components/admin/AdminNewsletter";
import { AdminLinkedIn } from "@/components/admin/AdminLinkedIn";
import { AdminEvents } from "@/components/admin/AdminEvents";
import { AdminAgap } from "@/components/admin/AdminAgap";

const LEAD_COLS = [["created_at", "Date"], ["alert_status", "Email alert"], ["sponsor_name", "Sponsor"], ["name", "Name"], ["email", "Email"], ["company", "Company"], ["article_slug", "Article"], ["message", "Message"]];
const INQ_COLS = [["created_at", "Date"], ["company", "Company"], ["name", "Name"], ["email", "Email"], ["package", "Package"], ["budget", "Budget"], ["message", "Message"]];
const USER_COLS = [["email", "Email"], ["name", "Name"], ["role", "Role"], ["tier", "Tier"], ["billing", "Billing"], ["subscription_status", "Status"]];

const Remote = ({ path, cols, testid }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(path).then((r) => setRows(r.data)); }, [path]);
  return <DataTable rows={rows} cols={cols} testid={testid} />;
};

export default function Admin() {
  const { user, logout } = useAuth();
  const tab = (v, l) => <TabsTrigger value={v} data-testid={`admin-tab-${v}`} className="rounded-none data-[state=active]:bg-[#0A0A0A] data-[state=active]:text-white">{l}</TabsTrigger>;
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-12" data-testid="admin-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div><p className="overline text-[#E5332A]">Editor desk</p><h1 className="font-display text-4xl font-bold mt-2">Command centre</h1></div>
        <div className="text-sm text-[#575757]">{user.email} · <button onClick={logout} data-testid="admin-logout-btn" className="text-[#E5332A] link-underline">Sign out</button></div>
      </div>
      <Tabs defaultValue={new URLSearchParams(window.location.search).get("tab") || "overview"} className="mt-10">
        <TabsList className="rounded-none bg-[#F4F4F4] flex-wrap h-auto">
          {tab("overview", "Revenue")}{tab("articles", "Articles")}{tab("sponsors", "Sponsors")}{tab("newsletter", "Tuesday Roast")}{tab("monthly", "Monthly Report")}{tab("linkedin", "LinkedIn")}{tab("events", "Events")}{tab("agap", "AGAP")}{tab("leads", "Sponsor leads")}{tab("inquiries", "Inquiries")}{tab("readers", "Readers")}
        </TabsList>
        <TabsContent value="overview" className="mt-8"><AdminOverview /></TabsContent>
        <TabsContent value="articles" className="mt-8"><AdminArticles /></TabsContent>
        <TabsContent value="sponsors" className="mt-8"><AdminSponsors /></TabsContent>
        <TabsContent value="newsletter" className="mt-8"><AdminNewsletter /></TabsContent>
        <TabsContent value="monthly" className="mt-8"><AdminMonthly /></TabsContent>
        <TabsContent value="linkedin" className="mt-8"><AdminLinkedIn /></TabsContent>
        <TabsContent value="events" className="mt-8"><AdminEvents /></TabsContent>
        <TabsContent value="agap" className="mt-8"><AdminAgap /></TabsContent>
        <TabsContent value="leads" className="mt-8"><Remote path="/admin/leads" cols={LEAD_COLS} testid="admin-leads-table" /></TabsContent>
        <TabsContent value="inquiries" className="mt-8"><Remote path="/admin/inquiries" cols={INQ_COLS} testid="admin-inquiries-table" /></TabsContent>
        <TabsContent value="readers" className="mt-8"><Remote path="/admin/users" cols={USER_COLS} testid="admin-users-table" /></TabsContent>
      </Tabs>
    </div>
  );
}
